import React, { useState} from "react";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import "./style.css";
import Card from "../Card";
import { useNavigate } from "react-router-dom";
import ModalContent from "./ModalContent";
import services from "../../constants/services";

function Services() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const resolveFunction = (obj) => {
    switch (obj.type) {
    case 'link':
      if(obj.target === 'blank') {
        window.open(obj.href)
      } else {
        navigate(obj.href);
      }
      break;
    case 'modal':
      setCurrentService(services.find(s => s.id === obj.id))
      onOpenModal()
      break;
    
    default:
      break;
    }
  }
  const [currentService, setCurrentService] = useState(services[0])

  return      <div style={{  backgroundColor: '#695036',  borderRadius: '5px', padding:'2% 0'}}>
    <Modal classNames={{
      modal: 'customModal',
    }} open={open} onClose={onCloseModal} >
      <ModalContent service={currentService}/>
    </Modal>
    <div style={{margin: '0 5%',}}>
      <h1 style={{fontSize: 'calc(16px + 2vw)'}}>Serviços</h1>
      <div className='cards-container'>
        {services.map(({title, desc, ... rest}) => <Card         
          onClick={() => resolveFunction(rest)}
          key={title} desc={desc} title={title}/>)}
      </div>
    </div>
  </div>
    
  
}

export default Services;
